<template>
  <FormPanel
      headline="Create Layout"
      :errors="errors"
      :layout-categories="layoutCategories"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentLayouts/Panels/Form'

export default {
  components: { FormPanel},

  props: {
    portal: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/content-layouts', {...data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The content layout was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/layouts')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
